module.exports = __webpack_public_path__ + "img/clogo.674bf8b6.png";